import React, { FC, useState } from "react";
import { AutoAwesome } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

import {
  StyledListItemIcon,
  StyledListItemText,
  StyledMenuItem,
} from "../../ActionsDropdown.styled";
import { AIImportDialog } from "./AIImportDialog";

import { useUserStore } from "@store/user";
import { useMultistepFormStore } from "@components/common/MultistepForm/MultistepForm.store";

interface AIImportProps {}

const AIImport: FC<AIImportProps> = () => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const { t } = useTranslation();
  const { user } = useUserStore();
  const {
    formSettings: {
      formBasics: { id },
    },
  } = useMultistepFormStore();

  const handleOpenDialog = (): void => {
    setDialogOpen(true);
  };

  const handleCloseDialog = (): void => {
    setDialogOpen(false);
  };

  return (
    <>
      <StyledMenuItem onClick={handleOpenDialog}>
        <StyledListItemIcon>
          <AutoAwesome fontSize="medium" />
        </StyledListItemIcon>
        <StyledListItemText>{t("forms.aiImportTitle")}</StyledListItemText>
      </StyledMenuItem>
      <AIImportDialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        formId={id}
        user={user}
      />
    </>
  );
};

export default AIImport;
